import TableVM from '../table-vm';
export default Kadenze.Util.extendObj(TableVM, function() {
  var self = this;
  self.$el = $('#summary-tab-content');
  self.params = {
    page: ko.observable(1),
    page_size: ko.observable(20),
    student_sort: ko.observable('ASC'),
    search: ko.observable(''),
    gtd_mode: ko.observable('standard')
  };
  self.coursework_families = ko.observableArray([]);
  self.student_ids = ko.observableArray([]);
  self.students = ko.observableArray([]);
  self.show_attendance = ko.observable(false);
  self.gtd_mode = ko.observable('standard');


  self.initUI = function () {
    var $searchEl = $('#summarySearch');
    $searchEl.on('keypress', function(event) {
      var keycode = (event.keyCode ? event.keyCode : event.which);
      if(keycode == '13') {
        $searchEl.blur();
      }
    });

    var $dropDowns = self.$el.find('.js-table-dropdown');
    $dropDowns.on('shown.bs.dropdown', function () {
      var $menu = $(this);
      self.updateMenuPosition($menu);
    });
  };

  self.bindFilters = function () {
    _.each(_.keys(self.params), function (key) {
      self.params[key].subscribe(self.filterChanged, self);
    });
  };

  self.toggleGTDMode = function () {
    if (self.gtd_mode() == 'standard') {
      self.gtd_mode('presumptive');
      self.params.gtd_mode('presumptive');
    } else {
      self.gtd_mode('standard');
      self.params.gtd_mode('standard');
    }
    self.$el.click(); //Hack to close selectpicker & menus
  };

  self.getSheet = function(url, params) {
    params = params ? params : ko.mapping.toJS(self.params);
    url = url ? url : Kadenze.Routes.course_gradebook_summary_index_path(self.course_id, params);

    var request = new Kadenze.AjaxRequest({
      type: 'GET',
      url: url,
      timeout: 60000,
      beforeSend: function (xhr, settings) {
        self.request_pool.add(xhr);
      }
    });

    request.done(function(data) {
      self.bindData(data);
    });

    request.fail(function(xhr, textStatus, message) {
      if (textStatus == 'abort') {
        return;
      }
      new Kadenze.Notice.error({ message: Kadenze.I18n.t('notice.unexpected_error') });
      console.warn('Error retrieving sheet data:', xhr);
    });

    request.always(function(data) {
      Kadenze.PaginationBinding.applyBindingsWithTextInput(self.pageChanged.bind(self));
    });

    return request;
  };

  self.bindData = function(data) {
    var mapped_coursework_families = ko.mapping.fromJS(data.coursework_families);
    self.coursework_families(mapped_coursework_families());

    self.students([]);

    self.student_ids(data.student_ids);

    self.paginator(data.paginator);
    self.show_attendance(data.show_attendance);

    if (self.student_ids().length > 0) {
      self.mp = new Mprogress({
        template: 1,
        start: true,
        parent: '#' + self.$el.attr('id') + ' .gradesheet-table'
      });

      _.each(self.student_ids(), function(student_id) {
        self.getStudent(student_id);
      });

      self.hidePlaceholder();
    } else {
      self.showPlaceholder('no_results');
    }
  };

  self.getStudent = function(student_id) {
    var url = Kadenze.Routes.show_course_gradebook_summary_index_path(self.course_id, student_id);

    var request = new Kadenze.AjaxRequest({
      type: 'GET',
      url: url,
      data: null,
      timeout: 60000,
      beforeSend: function (xhr, settings) {
        self.request_pool.add(xhr);
      }
    });

    request.done(function(data) {
      var mapped_student = ko.mapping.fromJS(data.student);
      self.students.push(mapped_student);

      var completion = self.students().length / self.student_ids().length;
      self.mp.set(completion);
      if (completion == 1) {
        self.mp.end();
      }
    });

    request.fail(function(xhr, textStatus, message) {
      if (textStatus == 'abort') {
        return;
      }
      console.log('Error retrieving row data:', xhr);
    });
  };

  self.findStudent = function(student_id) {
    return _.find(self.students(), function (student) {
      return student.id() == student_id;
    });
  };

  self.toggleStudentSort = function () {
    if (self.params.student_sort() == 'ASC') {
      self.params.student_sort('DESC');
    } else {
      self.params.student_sort('ASC');
    }
  };

  self.exportTable = function () {
    var url = Kadenze.Routes.export_course_gradebook_summary_index_path(self.course_id);
    window.open(url, '_blank');
    Kadenze.Analytics.track('grade', 'download', {type: 'global_summary'});
  };

  const __construct = function(that) {
    console.log('constructor called for Kadenze.InstructorGradebook.SummaryViewModel');
    that.course_id = $('#course_id').val();
    that.showPlaceholder('loading');
    that.getSheet();
    that.bindFilters();
  }(this);
});

